import { ca } from '@cian/analytics';

export const trackChangeVASPopupShow = () => {
  ca('event', {
    name: 'oldevent',
    category: 'ChangeActiveVASPopup',
    action: 'show',
  });
};

export const trackChangeVASPopupClick = (label) => {
  ca('event', {
    name: 'oldevent',
    category: 'ChangeActiveVASPopup',
    action: 'click',
    label,
  });
};
